<template>
    <div class="Settings">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    watch: {
        $route(val) {
            this.routeName = val.name;
        }
    },

    data() {
        return {
            routeName: this.$route.name
        };
    },

    methods: {
        goTo(el) {
            const element = document.querySelector(el);
            element.scrollIntoView({ behavior: 'smooth', block: "center", inline: "nearest" });
        }
    }
};
</script>

<style lang="scss">
.Settings {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
}

.Settings__navigation {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: flex-start;
    flex: 0 0 100%;
    width: 100%;
    padding: 24px;

    @media (min-width: 600px) {
        flex: 0 0 24%;
        width: 24%;
        min-height: 100%;
        padding: 32px 24px 24px;
    }

    h1 {
        font-size: 0.98rem !important;
        font-weight: bold !important;
        margin-bottom: 12px !important;
    }
}

.Settings__navigation__title {
    flex: 0 0 100%;
    width: 100%;
}

.Settings__navigation__menu {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
    margin: 0 !important;
    padding: 0 !important;
    list-style: none;
}

.Settings__navigation__menu__item {
    flex: 0 0 100%;
    width: 100%;
    padding: 0;
    margin: 0;

    a {
        font-size: 0.9rem !important;
        text-decoration: none;

        &:hover,
        &:focus,
        &:active {
            text-decoration: underline;
        }
    }
}

.Settings__navigation__menu__item + .Settings__navigation__menu__item {
    margin: 8px 0 0;
}

.EmailSettingMenu {
    list-style: none !important;
    margin: 0 !important;
    padding: 0 0 0 12px !important;

    a {
        color: $secondary-500 !important;
    }
}

</style>
